import { Box, Grid, Typography } from '@mui/material';
import React from 'react';
import { useStyles } from '../../style';
import { AppButton } from '../../../../Components/AppButton';
import KenColors from '../../../../Helpers/Themes/kenColors';

const TableContainer = () => {
  const classes = useStyles();
  return (
    <Box sx={{ overflowX: 'auto', mt: 3 }}>
      <Box className={classes.tableContainer} sx={{ minWidth: '800px' }}>
        {/* Table Header */}
        <Grid container style={{ backgroundColor: '#EAEFFF', color: '#172E7D', padding: 12 }}>
          <Grid item xs={2}>
            <Typography
              sx={{
                fontWeight: 500,
                fontSize: '12px',
                '@media (min-width: 1280px) and (max-width: 1300px)': {
                  fontSize: '10px',
                },
              }}
            >
              Course Code
            </Typography>
          </Grid>
          <Grid item xs={3}>
            <Typography
              sx={{
                fontWeight: 500,
                fontSize: '12px',
                '@media (min-width: 1280px) and (max-width: 1300px)': {
                  fontSize: '10px',
                },
              }}
            >
              Course
            </Typography>
          </Grid>
          <Grid item xs={1}>
            <Typography
              sx={{
                fontWeight: 500,
                fontSize: '12px',
                '@media (min-width: 1280px) and (max-width: 1300px)': {
                  fontSize: '10px',
                },
              }}
            >
              Credit
            </Typography>
          </Grid>
          <Grid item xs={2}>
            <Typography
              sx={{
                fontWeight: 500,
                fontSize: '12px',
                '@media (min-width: 1280px) and (max-width: 1300px)': {
                  fontSize: '10px',
                },
              }}
            >
              Grade
            </Typography>
          </Grid>
          <Grid item xs={4} sx={{ display: 'flex', justifyContent: 'center' }}>
            <Typography
              sx={{
                fontWeight: 500,
                fontSize: '12px',
                '@media (min-width: 1280px) and (max-width: 1300px)': {
                  fontSize: '10px',
                },
              }}
            >
              Marks obtained
            </Typography>
          </Grid>
        </Grid>

        {/* Sub-header for Marks Obtained */}
        <Grid container style={{ color: '#172E7D', padding: 12, borderBottom: '1px solid #E5E6EA' }}>
          <Grid item xs={2}></Grid>
          <Grid item xs={3}></Grid>
          <Grid item xs={1}></Grid>
          <Grid item xs={2}></Grid>
          <Grid item xs={4}>
            <Grid container sx={{ display: 'flex', justifyContent: 'center' }}>
              <Grid item xs={3}>
                <Typography
                  sx={{
                    fontWeight: 500,
                    fontSize: '12px',
                    '@media (min-width: 1280px) and (max-width: 1300px)': {
                      fontSize: '10px',
                    },
                  }}
                >
                  I term
                </Typography>
              </Grid>
              <Grid item xs={3}>
                <Typography
                  sx={{
                    fontWeight: 500,
                    fontSize: '12px',
                    '@media (min-width: 1280px) and (max-width: 1300px)': {
                      fontSize: '10px',
                    },
                  }}
                >
                  II term
                </Typography>
              </Grid>
              <Grid item xs={3}>
                <Typography
                  sx={{
                    fontWeight: 500,
                    fontSize: '12px',
                    '@media (min-width: 1280px) and (max-width: 1300px)': {
                      fontSize: '10px',
                    },
                  }}
                >
                  Total
                </Typography>
              </Grid>
            </Grid>
          </Grid>
        </Grid>

        {/* Table Rows */}
        <Box>
          <Typography sx={{ textAlign: 'left', fontSize: '12px', fontWeight: 600, ml: 7, mt: 2 }}>Theory exams</Typography>
          <Grid container sx={{ p: 1, mt: 2, borderBottom: '1px solid #E5E6EA' }}>
            <Grid item xs={2}>
              <Typography sx={{ fontSize: '12px', fontWeight: 400 }}>C2022/23S2</Typography>
              <Typography sx={{ mt: 3, fontSize: '12px', fontWeight: 400 }}>C2022/23S2</Typography>
              <Typography sx={{ mt: 3, fontSize: '12px', fontWeight: 400 }}>C2022/23S2</Typography>
            </Grid>
            <Grid item xs={3}>
              <Typography sx={{ fontSize: '12px', fontWeight: 400 }}>Basics of business communication</Typography>
              <Typography sx={{ mt: 3, fontSize: '12px', fontWeight: 400 }}>Basics of business communication</Typography>
              <Typography sx={{ mt: 3, fontSize: '12px', fontWeight: 400 }}>Basics of business communication</Typography>
            </Grid>
            <Grid item xs={1}>
              <Typography sx={{ fontSize: '12px', fontWeight: 400 }}>2</Typography>
              <Typography sx={{ mt: 3, fontSize: '12px', fontWeight: 400 }}>2</Typography>
              <Typography sx={{ mt: 3, fontSize: '12px', fontWeight: 400 }}>2</Typography>
            </Grid>
            <Grid item xs={2}>
              <Typography sx={{ fontSize: '12px', fontWeight: 400 }}>A+ </Typography>
              <Typography sx={{ mt: 3, fontSize: '12px', fontWeight: 400 }}>A+ </Typography>
              <Typography sx={{ mt: 3, fontSize: '12px', fontWeight: 400 }}>A+ </Typography>
            </Grid>
            <Grid item xs={4}>
              <Grid container sx={{ display: 'flex', justifyContent: 'center' }}>
                <Grid item xs={3}>
                  <Typography sx={{ fontSize: '12px', fontWeight: 400 }}>69</Typography>
                  <Typography sx={{ mt: 3, fontSize: '12px', fontWeight: 400 }}>69</Typography>
                  <Typography sx={{ mt: 3, fontSize: '12px', fontWeight: 400 }}>69</Typography>
                </Grid>
                <Grid item xs={3}>
                  <Typography sx={{ fontSize: '12px', fontWeight: 400 }}>23</Typography>
                  <Typography sx={{ mt: 3, fontSize: '12px', fontWeight: 400 }}>23</Typography>
                  <Typography sx={{ mt: 3, fontSize: '12px', fontWeight: 400 }}>23</Typography>
                </Grid>
                <Grid item xs={3}>
                  <Typography sx={{ fontSize: '12px', fontWeight: 400 }}>92</Typography>
                  <Typography sx={{ mt: 3, fontSize: '12px', fontWeight: 400 }}>92</Typography>
                  <Typography sx={{ mt: 3, fontSize: '12px', fontWeight: 400 }}>92</Typography>
                </Grid>
              </Grid>
            </Grid>
          </Grid>
        </Box>

        {/* Additional Rows */}
        <Box>
          <Typography sx={{ textAlign: 'left', fontSize: '12px', fontWeight: 600, ml: 7, mt: 2 }}>Practical exams</Typography>
          <Grid container sx={{ p: 1, mt: 2, borderBottom: '1px solid #E5E6EA' }}>
            <Grid item xs={2}>
              <Typography sx={{ fontSize: '12px', fontWeight: 400 }}>C2022/23S2</Typography>
            </Grid>
            <Grid item xs={3}>
              <Typography sx={{ fontSize: '12px', fontWeight: 400 }}>Basics of business communication</Typography>
            </Grid>
            <Grid item xs={1}>
              <Typography sx={{ fontSize: '12px', fontWeight: 400 }}>2</Typography>
            </Grid>
            <Grid item xs={2}>
              <Typography sx={{ fontSize: '12px', fontWeight: 400 }}>A+ </Typography>
            </Grid>
            <Grid item xs={4}>
              <Grid container sx={{ display: 'flex', justifyContent: 'center' }}>
                <Grid item xs={3}>
                  <Typography sx={{ fontSize: '12px', fontWeight: 400 }}>69</Typography>
                </Grid>
                <Grid item xs={3}>
                  <Typography sx={{ fontSize: '12px', fontWeight: 400 }}>23</Typography>
                </Grid>
                <Grid item xs={3}>
                  <Typography sx={{ fontSize: '12px', fontWeight: 400 }}>92</Typography>
                </Grid>
              </Grid>
            </Grid>
          </Grid>
        </Box>

        {/* Footer Section */}
        <Box sx={{ backgroundColor: '#F6F8FB' }}>
          <Grid container sx={{ p: 2 }}>
            <Grid item xs={7} sx={{ display: 'flex', justifyContent: 'start' }}>
              <AppButton size="small" variant="contained" className={classes.postJobBtns} others={{ color: 'white', width: 180, height: '27px' }} background="#373A45">
                <Typography sx={{ fontSize: '12px', fontWeight: 500 }}>Grand total: 342/500</Typography>
              </AppButton>
              <AppButton size="small" variant="contained" className={classes.postJobBtns} others={{ color: 'white', width: 100, marginLeft: 10, height: '27px' }} background="#373A45">
                <Typography sx={{ fontSize: '12px', fontWeight: 500 }}>CGPA: 7.1</Typography>
              </AppButton>
              <AppButton size="small" variant="contained" className={classes.postJobBtns} others={{ color: '#D32F2F', width: 150, marginLeft: 10, height: '27px' }} background="#FBEAEA">
                <Typography sx={{ fontSize: '12px', fontWeight: 500 }}>Result: Fail</Typography>
              </AppButton>
            </Grid>
            <Grid item xs={5} style={{ display: 'flex', justifyContent: 'end' }}>
              <AppButton size="small" variant="contained" className={classes.postJobBtns} others={{ color: KenColors.kenWhite, width: 200, height: '36px' }}>
                <Typography sx={{ fontSize: '12px', fontWeight: 600 }}>Download Grade Card</Typography>
              </AppButton>
            </Grid>
          </Grid>
        </Box>
      </Box>
    </Box>
  );
};

export default TableContainer;
